



























































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import TipoBandeiraCartaoModel from "@/models/commons/TipoBandeiraCartaoModel";
import ContabilContaReceberService from "@/service/ContabilContaReceberService";
import { RelatorioContaReceberModel } from "@/models/contabil/contas-receber/RelatorioContaReceberModel";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { ContaReceberModel } from "@/models/contabil/contas-receber/ContaReceberModel";
import moment from "moment";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog
  },
})
export default class ContaReceber extends Vue {
  $refs!: {
    relatorioObserver: InstanceType<typeof ValidationObserver>;
    dataBaixaObserver: InstanceType<typeof ValidationObserver>;
  };

  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  contasReceber = [] as ContaReceberModel[];

  loading: boolean = false;

  filtroContaReceber = {
    inicio: undefined,
    fim: undefined,
    today: moment().format("YYYY-MM-DD"),
    status: {
      name: undefined,
      descricao: "Todas",
    },
  };

  cabecalho = [
    {
      text: "Data recebimento",
      value: "dataBaixa",
      align: "center",
      divider: true,
    },
    {
      text: "Data pagamento",
      value: "dataPagamento",
      align: "center",
      divider: true,
    },
    {
      text: "Data NFSe",
      value: "dataEmissaoNF",
      align: "center",
      divider: true,
    },
    {
      text: "CPF / CNPJ",
      value: "cpfCnpjCliente",
      align: "center",
      divider: true,
    },
      {
      text: "Cliente",
      value: "nomeCliente",
      width: "20%",
      align: "center",
      divider: true,
    },
    { text: "Natureza", value: "naturezaServico", width: "10%", divider: true },
    { text: "Ordem serviço", value: "codigoOrdemServico", width: "10%", divider: true },
    { text: "Taxa cartão", value: "taxaCartao", width: "5%", divider: true },
    { text: "Valor bruto", value: "valorBruto", width: "5%", divider: true },
    { text: "Valor liquido", value: "valorLiquido", width: "5%", divider: true },
    { text: "Cartão", value: "bandeiraCartao", width: "5%", divider: true },
    { text: "Status", value: "status", width: "10%", divider: true },
    {
      text: "Ações",
      value: "actions",
      sortable: false,
      width: "10%",
      divider: true,
    },
  ];

  relatorio: RelatorioContaReceberModel = {
    inicio: undefined,
    fim: undefined,
    naturezaServico: { valor: undefined, descricao: "Todas" },
    tipoCartao: { codigo: undefined, descricao: "Todos" }
  };

  tiposNaturezaServico = [
    { valor: undefined, descricao: "Todas" },
    { valor: "ASSISTENCIA_24H", descricao: "Assistência 24h" },
    { valor: "ORCAMENTO_AUTOMOTIVO", descricao: "Orçamento Automotivo Online" },
    { valor: "SERVICOS_SAUDE", descricao: "Serviços de Saúde" },
  ];

   tipoCartoes: TipoBandeiraCartaoModel[] = [
      { codigo: undefined, descricao: "Todos" },
      { codigo: 'MASTERCARD', descricao: "MasterCard" },
      { codigo: 'VISA', descricao: "Visa" },
      { codigo: 'AMEX', descricao: "American Express" },
      { codigo: 'ELO', descricao: "Cielo" },
      { codigo: 'DINERS', descricao: "Diners"},
      { codigo: 'DISCOVER', descricao: "Discover"},
      { codigo: 'HIPERCARD', descricao: "Hipercard"},
      { codigo: 'FROTA', descricao: "Frota"}
  ];

  gerarRelatorio() {
    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        ContabilContaReceberService.gerarRelatorio(this.relatorio)
          .then((res) => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data]));

            let fileLink = document.createElement("a");

            fileLink.href = fileURL;

            fileLink.setAttribute("download", "relatorio_conta_receber.pdf");

            document.body.appendChild(fileLink);

            fileLink.click();

            this.loading = false;
          })
          .catch((err) => {
            this.openDialog(false, 'Erro', err.message);
            this.loading = false;
          });

        this.limparformulario();
      }
    });
  }

  gerarRelatorioExcel() {
    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        ContabilContaReceberService.gerarRelatorioExcel(this.relatorio)
          .then((res) => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data]));

            let fileLink = document.createElement("a");

            fileLink.href = fileURL;

            fileLink.setAttribute("download", "relatorio_conta_receber.xls");

            document.body.appendChild(fileLink);

            fileLink.click();

            this.loading = false;
          })
          .catch((err) => {
            this.openDialog(false, 'Erro', err.message);
            this.loading = false;
          });

        this.limparformulario();
      }
    });
  }

    filtrarContaReceber() {
      this.$refs.relatorioObserver.validate().then((valid: boolean) => {
        if (valid) {
          ContabilContaReceberService.filtrar(this.relatorio).then( 
            (res) => {
              this.contasReceber = res.data;
            }
          );
        } else {
          setTimeout(() => {
            const errors = Object.entries(this.$refs.relatorioObserver.errors)
              .map(([key, value]) => ({ key, value }))
              .filter((error) => error["value"].length);
            this.$refs.relatorioObserver.refs[
              errors[0]["key"]
            ].$el.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }, 100);

        }
      });
    }

  limparformulario() {
    this.relatorio = {
      inicio: undefined,
      fim: undefined,
      naturezaServico: undefined,
      tipoCartao: undefined,
    };
    this.$refs.relatorioObserver.reset();
  }

  private openDialog(success: boolean, title: string, message: string) {
    this.successDialog = success;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  // CONFIRM MODAL
  showConfirmModal = false;
  confirmTitle = "";
  confirmMessage = "";
  dataBaixa = "";
  idContaReceber:number = 0;

  public openConfirmModal(
    title: string,
    message: string,
    idContaReceber: number
  ): void {
    this.confirmTitle = title;
    this.confirmMessage = message;
    this.idContaReceber = idContaReceber;
    this.showConfirmModal = true;
  }

  public confirmModalOnClose(yes: boolean): void {
    if (!yes) {
      this.showConfirmModal = false;
    } else {
        this.$refs.dataBaixaObserver.validate().then((valid) => {
            if (valid && !!this.idContaReceber) {
                ContabilContaReceberService.realizarBaixa(this.idContaReceber, this.dataBaixa).then( 
                  (res) => {
                    this.showConfirmModal = false;
                    this.filtrarContaReceber();
                  });
            }
        });
    }
  }

  get btnColor() {
    return this.successDialog ? '#00CD96' : 'error';
  }

  get btnText() {
    return this.successDialog ? 'Ok, entendi' : 'Fechar';
  }

  get dialogImg() {
    return this.successDialog ? 'success.png' : 'error.png';
  }
}
